var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPastSwaps = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#past-swaps_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#F6F9FC"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#58728C",
  d: "M30.03 59.162a3.83 3.83 0 0 1 3.83-3.83h13.895v21.776H30.03V59.162Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18.048,
  height: 4.899,
  x: 27.396,
  y: 42.941,
  fill: "#fff",
  rx: 0.688
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.35,
  d: "M42.69 55.332h5.064v22.029H42.69z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M43.78 51.003v-2.88h.765c.705 0 1.276-.572 1.276-1.277V43.95c0-.706-.571-1.277-1.276-1.277h-16.16c-.705 0-1.276.572-1.276 1.277v2.897c0 .705.571 1.277 1.276 1.277h.765v2.922a5.857 5.857 0 0 0-2.768 2.142 5.833 5.833 0 0 0-1.049 3.335v19.494c0 .705.572 1.277 1.277 1.277h19.834c.705 0 1.276-.572 1.276-1.277V56.525c0-1.215-.38-2.4-1.085-3.39a5.858 5.858 0 0 0-2.855-2.132ZM43.8 48.107H29.389"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B9D9A5",
  d: "M76.95 59.162a3.83 3.83 0 0 1 3.83-3.83h13.895v21.776H76.95V59.162Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18.048,
  height: 4.899,
  x: 74.316,
  y: 42.941,
  fill: "#fff",
  rx: 0.688
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.35,
  d: "M89.609 55.332h5.064v22.029h-5.064z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M90.7 51.003v-2.88h.765c.705 0 1.276-.572 1.276-1.277V43.95c0-.706-.571-1.277-1.276-1.277h-16.16c-.705 0-1.277.572-1.277 1.277v2.897c0 .705.572 1.277 1.277 1.277h.765v2.922a5.857 5.857 0 0 0-2.769 2.142 5.834 5.834 0 0 0-1.048 3.335v19.494c0 .705.572 1.277 1.277 1.277h19.834c.705 0 1.276-.572 1.276-1.277V56.525c0-1.215-.38-2.4-1.085-3.39a5.858 5.858 0 0 0-2.856-2.132ZM90.72 48.107H76.309"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#58728C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  clipPath: "url(#past-swaps_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.826 30.336a36.686 36.686 0 0 0-43.055 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m80.13 23.31 1.803 7.724-7.972.915M37.868 89.69a36.686 36.686 0 0 0 43.055 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38.423 96.442-1.795-7.717 7.972-.914"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "past-swaps_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v120H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "past-swaps_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M82.986 22.666H35.708v74.7h47.278z"
})))));
export default SvgPastSwaps;